<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>
        <action-button type="default" text="" icon="content_copy" :icon_only="true" @click="duplicate" small v-if="modal != true" />

        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />
        <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />
        <action-button type="save" @click="save" />

        <action-button
          type="delete"
          @click="del(moduletemplate.id)"
          v-if="moduletemplate.id && $can('moduletemplate-delete') && modal != true"
        />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md3 sm6 xs12 class="d-none">
                <v-select
                  name="moduletemplate.template_type"
                  v-model="moduletemplate.template_type"
                  item-text="text"
                  item-value="key"
                  :items="dd_moduletemplate_template_type"
                  :label="$t('moduletemplates.template_type')"
                  :error-messages="errors.collect('moduletemplate.template_type')"
                  @change="templateTypeChange(moduletemplate.template_type, false)"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex lg3 md3 sm6 xs12>
                <v-autocomplete
                  name="moduletemplate.coursetypegroup_id"
                  v-model="moduletemplate.coursetypegroup_id"
                  :items="coursetypegroups"
                  item-text="name"
                  item-value="id"
                  :label="$t('moduletemplates.coursetypegroup_id')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('moduletemplate.coursetypegroup_id')"
                  @change="courseTypeGroupChange(moduletemplate.coursetypegroup_id)"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md3 sm6 xs12>
                <v-autocomplete
                  name="moduletemplate.coursetype_id"
                  v-model="moduletemplate.coursetype_id"
                  :items="coursetypes"
                  item-text="name"
                  item-value="id"
                  :label="$t('moduletemplates.coursetype_id')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('moduletemplate.coursetype_id')"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg4 md3 sm6 xs12>
                <v-text-field
                  name="moduletemplate.name"
                  v-model="moduletemplate.name"
                  class="required-field"
                  v-validate="'required|max:100'"
                  :label="$t('moduletemplates.name')"
                  :error-messages="errors.collect('moduletemplate.name')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md3 sm6 xs12>
                <v-select
                  name="moduletemplate.status"
                  v-model="moduletemplate.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_module_templates_status()"
                  :label="$t('moduletemplates.status')"
                  :error-messages="errors.collect('moduletemplate.status')"
                  :readonly="!allow_edit"
                  clearable
                ></v-select>
              </v-flex>

              <v-flex xs12>
                <v-textarea
                  name="moduletemplate.description"
                  v-model="moduletemplate.description"
                  :label="$t('moduletemplates.description')"
                  :error-messages="errors.collect('moduletemplate.description')"
                ></v-textarea>
              </v-flex>

              <v-flex lg2 md3 sm6 xs12>
                <v-checkbox
                  name="moduletemplate.hide_in_accomplishment"
                  v-model="moduletemplate.hide_in_accomplishment"
                  :error-messages="errors.collect('moduletemplate.hide_in_accomplishment')"
                  @change="changeHideInAccomplishment()"
                >
                  <template slot="label">
                    {{ $t("moduletemplates.hide_in_accomplishment") }}
                    <span class="ml-1"><help-text slot="append" :tooltip="$t('moduletemplates.hide_in_accomplishment_helptext')" /></span>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex lg2 md3 sm6 xs12>
                <v-checkbox
                  name="moduletemplate.hide_in_enrolment"
                  v-model="moduletemplate.hide_in_enrolment"
                  :label="$t('moduletemplates.hide_in_enrolment')"
                  :error-messages="errors.collect('moduletemplate.hide_in_enrolment')"
                  @change="changeHideInEnrolment()"
                ></v-checkbox>
              </v-flex>
              <v-flex lg3 md3 sm6 xs12>
                <v-select
                  name="moduletemplate.select_visibility"
                  v-model="moduletemplate.select_visibility"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_select_visibility()"
                  :label="$t('moduletemplates.select_visibility')"
                  :error-messages="errors.collect('moduletemplate.select_visibility')"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex lg4 md3 sm6 xs12>
                <v-autocomplete
                  name="moduletemplate.req_coursetemplate_id"
                  v-model="moduletemplate.req_coursetemplate_id"
                  :items="coursetemplates"
                  item-text="name"
                  item-value="id"
                  :label="$t('moduletemplates.req_coursetemplate_id')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('moduletemplate.req_coursetemplate_id')"
                  clearable
                >
                  <help-text slot="append-outer" :tooltip="$t('moduletemplates.required_module_course_helptext')" />
                </v-autocomplete>
              </v-flex>
              <v-flex lg4 md3 sm6 xs12>
                <v-autocomplete
                  name="moduletemplate.req_module_id"
                  v-model="moduletemplate.req_module_id"
                  :items="moduletemplates"
                  item-text="name"
                  item-value="id"
                  :label="$t('moduletemplates.req_module_id')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('moduletemplate.req_module_id')"
                  clearable
                >
                  <help-text slot="append-outer" :tooltip="$t('moduletemplates.required_module_course_helptext')" />
                </v-autocomplete>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-checkbox
                  name="moduletemplate.is_included"
                  v-model="moduletemplate.is_included"
                  :label="$t('moduletemplates.is_included')"
                  :error-messages="errors.collect('moduletemplate.is_included')"
                ></v-checkbox>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12 v-if="!moduletemplate.is_included && (course_type == 1 || course_type == null)">
                <v-text-field
                  name="moduletemplate.price"
                  v-model="computedPrice"
                  @keypress="$keyDown_PriceOnly($event)"
                  :hint="'Format:' + PRICE_FORMAT"
                  :label="$t('moduletemplates.price')"
                  :error-messages="errors.collect('moduletemplate.price')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12 v-if="!moduletemplate.is_included && (course_type == 1 || course_type == null)">
                <v-text-field
                  name="moduletemplate.price_vat"
                  v-model="computedPriceVat"
                  @keypress="$keyDown_PriceOnly($event)"
                  :hint="'Format:' + PRICE_FORMAT"
                  :label="$t('moduletemplates.price_vat')"
                  :error-messages="errors.collect('moduletemplate.price_vat')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-text-field
                  name="moduletemplate.req_hours"
                  v-model="moduletemplate.req_hours"
                  v-validate="'decimal'"
                  :label="$t('moduletemplates.req_hours')"
                  :error-messages="errors.collect('moduletemplate.req_hours')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12 v-if="false">
                <v-select
                  name="moduletemplate.type"
                  v-model="moduletemplate.type"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_moduletemplate_type()"
                  :label="$t('moduletemplates.type')"
                  :error-messages="errors.collect('moduletemplate.type')"
                  :readonly="!allow_edit"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex lg4 md4 sm4 xs12>
                <v-text-field
                  name="moduletemplate.internal_note"
                  v-model="moduletemplate.internal_note"
                  v-validate="'max:25'"
                  :label="$t('moduletemplates.internal_note')"
                  :error-messages="errors.collect('moduletemplate.internal_note')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12 v-if="false">
                <v-checkbox
                  name="moduletemplate.is_joint"
                  v-model="moduletemplate.is_joint"
                  :label="$t('moduletemplates.is_joint')"
                  :error-messages="errors.collect('moduletemplate.is_joint')"
                  :readonly="!allow_edit"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12>
                <p class="text-right mb-0" v-if="moduletemplate.updated_by != null">
                  {{
                    $t("global.last_updated_by") +
                    (moduletemplate.updated_by == -1 ? $t("global.xl3_admin") : moduletemplate.updated_by_name)
                  }}
                  {{ moment.utc(moduletemplate.updated_at).format(DATE_FORMAT + " " + TIME_FORMAT) }}
                </p>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-2" v-if="!modal">
          <v-app-bar flat dense color="secondary">
            <v-toolbar-title class="subheading">{{ $t("moduleoptions.title") }}</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-checkbox
              name="moduletemplate.mandatory"
              class="mandatory-chkbox white--text mt-0"
              v-model="moduletemplate.mandatory"
              :label="$t('moduletemplates.mandatory')"
              dark
            ></v-checkbox>

            <action-button type="new" small @click="showForm(null, 'moduleoption', moduletemplate.id)" :icon_only="true" />
          </v-app-bar>
          <v-card-text class="px-4">
            <v-layout row wrap>
              <v-flex md12>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left" width="20%">{{ $t("moduleoptions.name") }}</th>
                        <th class="text-left">{{ $t("moduleoptions.price") }}</th>
                        <th class="text-left">{{ $t("moduleoptions.hours") }}</th>
                        <th class="text-left" width="12%">{{ $t("moduleoptions.enrol_select") }}</th>
                        <th class="text-left" width="12%">{{ $t("moduleoptions.mandatory_accomplishment") }}</th>
                        <th class="text-left" width="12%">
                          {{ $t("global.dd_select_visibility_expertise") }}
                        </th>
                        <th class="text-left" width="12%">
                          {{ $t("global.dd_select_visibility_course_certificate") }}
                        </th>
                        <th class="text-end" width="10%">{{ $t("global.actions") }}</th>
                      </tr>
                    </thead>
                    <tbody v-for="(moduleoption, index) in moduleoptions" :key="moduleoption.id">
                      <tr>
                        <td scope="row" :class="moduleoption.comment ? 'py-2' : ''">
                          <v-btn
                            icon
                            color="grey"
                            class="icon-order-btn"
                            @click="moduleOptionOrder(moduleoption.id, false)"
                            v-if="index >= 1"
                          >
                            <v-icon>fas fa-angle-up</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="grey"
                            class="icon-order-btn"
                            @click="moduleOptionOrder(moduleoption.id, true)"
                            v-if="index <= moduleoptions.length - 2"
                          >
                            <v-icon>fas fa-angle-down</v-icon>
                          </v-btn>

                          {{ moduleoption.name }}
                          <p v-if="moduleoption.comment" class="font-italic mb-0">( {{ moduleoption.comment }} )</p>
                        </td>
                        <td scope="row">{{ moduleoption.price }}</td>
                        <td scope="row">{{ moduleoption.hours }}</td>
                        <td scope="row">
                          <v-simple-checkbox :value="Boolean(moduleoption.enrol_select)" :readonly="true" hide-details></v-simple-checkbox>
                        </td>
                        <td scope="row">
                          <v-simple-checkbox
                            :value="Boolean(moduleoption.mandatory_accomplishment)"
                            :readonly="true"
                            hide-details
                          ></v-simple-checkbox>
                        </td>
                        <td scope="row">
                          <v-simple-checkbox
                            :value="Boolean(moduleoption.add_to_expertise)"
                            :readonly="true"
                            hide-details
                          ></v-simple-checkbox>
                        </td>
                        <td scope="row">
                          <v-simple-checkbox
                            :value="Boolean(moduleoption.add_to_course_certificate)"
                            :readonly="true"
                            hide-details
                          ></v-simple-checkbox>
                        </td>
                        <td class="text-end" scope="row">
                          <action-button
                            type="edit"
                            :icon_only="true"
                            small
                            @click="showForm(moduleoption.id, 'moduleoption', moduletemplate.id)"
                          />
                          <action-button type="delete" :icon_only="true" small @click="del_option(moduleoption.id)" />
                        </td>
                      </tr>
                      <tr>
                        <td :colspan="9" class="ct-td">
                          <v-card>
                            <v-app-bar flat dense color="white">
                              <v-toolbar-title class="body-2">{{ $t("coursetypes.title") }}</v-toolbar-title>

                              <v-spacer></v-spacer>

                              <action-button
                                type="new"
                                small
                                @click="showForm(null, 'moduleoptioncoursetype', moduleoption.id)"
                                :icon_only="true"
                              />
                            </v-app-bar>
                            <v-card-text class="px-4">
                              <v-simple-table>
                                <template v-slot:default>
                                  <thead>
                                    <tr>
                                      <!--<th class="text-left">{{ $t('moduleoptioncoursetypes.coursetype_id') }}</th>-->
                                      <th class="text-left">
                                        {{ $t("moduleoptioncoursetypes.name") }}
                                      </th>
                                      <th class="text-left">
                                        {{ $t("moduleoptioncoursetypes.price") }}
                                      </th>
                                      <th class="text-end" width="20%">{{ $t("global.actions") }}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <template v-for="coursetype in moduleoption.coursetypes">
                                      <tr :key="coursetype.id + '-td1'" :class="coursetype.comment ? 'tr-no-bottom-border' : ''">
                                        <!--<td scope="row">{{ coursetype.coursetype.category }}</td>-->
                                        <td scope="row">
                                          {{ coursetype.name }}
                                          <p v-if="coursetype.comment" class="font-italic mb-0">( {{ coursetype.comment }} )</p>
                                        </td>
                                        <td scope="row">{{ coursetype.price }}</td>
                                        <td scope="row" class="text-end">
                                          <action-button
                                            type="edit"
                                            :icon_only="true"
                                            small
                                            @click="showForm(coursetype.id, 'moduleoptioncoursetype', moduleoption.id)"
                                          />
                                          <action-button type="delete" :icon_only="true" small @click="del_option_ct(coursetype.id)" />
                                        </td>
                                      </tr>
                                    </template>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-card-text>
                          </v-card>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-dialog v-model="showDialogForm" persistent max-width="960px">
          <div class="form-modal pa-4">
            <component
              :is="currentLoadedForm.form"
              :id="currentLoadedForm.id"
              :coursetypegroup_id="moduletemplate.coursetypegroup_id"
              :moduletemplate_id="currentLoadedForm.moduletemplate_id"
              :moduleoption_id="currentLoadedForm.moduleoption_id"
              :coursetypes="currentLoadedForm.coursetypes"
              :select_visibility="currentLoadedForm.select_visibility"
              :disable_accomp_select="currentLoadedForm.disable_accomp_select"
              :from_module="currentFromModule"
              :disable_enrol_select="currentLoadedForm.disable_enrol_select"
              :modal="true"
              @return_modal_form="return_modal_form"
              @return_modal_cancel_form="return_modal_cancel_form"
            ></component>
          </div>
        </v-dialog>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "ModuleTemplateForm",

  props: ["id", "course_type", "modal"],

  components: {
    "moduleoption-form": () => import("../../moduleoptions/components/Form"),
    "moduleoptioncoursetype-form": () => import("../../moduleoptioncoursetypes/components/Form")
  },

  data() {
    return {
      allow_edit: false,
      allow_delete: false,
      dd_moduletemplate_template_type: this.$dd_moduletemplate_template_type(),

      page_title: "",
      predata: {},
      moduletemplate: {},
      moduletemplates: [],
      coursetemplates: [],
      coursetypegroups: [],
      coursetypes: [],

      currentFormId: "",
      currentModuleTemplateId: "",
      currentModuleOptionId: "",
      currentCourseTypes: [],
      currentForm: "",
      currentFromModule: "moduletemplate",
      showDialogForm: false,

      expanded: [],

      moduleoptions: [],
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: []
      },
      headers: [
        { text: this.$t("moduleoptions.name"), value: "name" },
        { text: this.$t("moduleoptions.price"), value: "price" },
        { text: this.$t("moduleoptions.hours"), value: "hours" },
        {
          text: this.$t("global.actions"),
          value: "actions",
          width: "20%",
          align: "end"
        }
      ],

      dictionary: {
        attributes: {
          "moduletemplate.name": this.$t("moduletemplates.name"),
          "moduletemplate.description": this.$t("moduletemplates.description"),
          "moduletemplate.coursetemplate_id": this.$t("coursetemplates.title"),
          "moduletemplate.req_hours": this.$t("moduletemplates.req_hours"),
          "moduletemplate.req_module_id": this.$t("moduletemplates.req_module_id"),
          "moduletemplate.req_coursetemplate_id": this.$t("moduletemplates.req_coursetemplate_id"),
          "moduletemplate.type": this.$t("moduletemplates.type"),
          "moduletemplate.template_type": this.$t("moduletemplates.template_type"),
          "moduletemplate.price": this.$t("moduletemplates.price"),
          "moduletemplate.price_vat": this.$t("moduletemplates.price_vat"),
          "moduletemplate.status": this.$t("moduletemplates.status"),
          "moduletemplate.is_joint": this.$t("moduletemplates.is_joint"),
          "moduletemplate.is_included": this.$t("moduletemplates.is_included"),
          "moduletemplate.internal_note": this.$t("moduletemplates.internal_note"),
          "moduletemplate.hide_in_accomplishment": this.$t("moduletemplates.hide_in_accomplishment"),
          "moduletemplate.hide_in_enrolment": this.$t("moduletemplates.hide_in_enrolment"),
          "moduletemplate.select_visibility": this.$t("moduletemplates.select_visibility")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.moduletemplate, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    currentLoadedForm: function () {
      let form,
        id,
        coursetypes,
        moduletemplate_id,
        moduleoption_id,
        select_visibility,
        disable_accomp_select,
        disable_enrol_select = null

      if (this.currentForm) {
        this.showDialogForm = true

        id = this.currentFormId
        form = this.currentForm
        coursetypes = this.currentCourseTypes
        moduletemplate_id = this.currentModuleTemplateId
        moduleoption_id = this.currentModuleOptionId
        select_visibility = this.moduletemplate.select_visibility
        disable_accomp_select = Boolean(this.moduletemplate.hide_in_accomplishment)
        disable_enrol_select = Boolean(this.moduletemplate.hide_in_enrolment)
      }

      return {
        id: id,
        form: form,
        coursetypes: coursetypes,
        moduletemplate_id: moduletemplate_id,
        moduleoption_id: moduleoption_id,
        select_visibility: select_visibility,
        disable_accomp_select: disable_accomp_select,
        disable_enrol_select: disable_enrol_select
      }
    },
    computedPrice: {
      get() {
        return this.$priceFormatGetter(this.moduletemplate.price)
      },
      set(val) {
        this.$set(this.moduletemplate, "price", this.$priceFormatSetter(val))
      }
    },
    computedPriceVat: {
      get() {
        return this.$priceFormatGetter(this.moduletemplate.price_vat)
      },
      set(val) {
        this.$set(this.moduletemplate, "price_vat", this.$priceFormatSetter(val))
      }
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    this.init()
  },

  methods: {
    init() {
      let lists = [
        { key: "moduletemplates", module: "moduletemplates", query: "show_all=true" },
        { key: "coursetemplates", module: "coursetemplates", query: "show_all=true" },
        { key: "coursetypegroups", module: "coursetypegroups", query: "show_all=true" }
      ]

      axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
        this.coursetypegroups = res.data.coursetypegroups
        this.coursetemplates = res.data.coursetemplates
        this.moduletemplates = res.data.moduletemplates.filter((item) => item.id != this.id)

        if (!this.id) {
          this.moduletemplate = {}

          this.moduletemplate = {
            status: this.$getDefaultDropdown(this.$dd_module_templates_status()),
            mandatory: 1
          }

          // JSON stringify and parse to remove variable reactiveness
          this.predata = JSON.parse(JSON.stringify(this.moduletemplate))

          this.setReadOnly()
          this.setPageTitle()
        } else {
          this.title = this.$t("moduletemplates.update_title")

          axios
            .get(this.API_URL + "moduletemplate/" + this.id)
            .then((res) => {
              this.moduletemplate = res.data.data

              // JSON stringify and parse to remove variable reactiveness
              this.predata = JSON.parse(JSON.stringify(this.moduletemplate))

              this.setReadOnly()
              this.setPageTitle()
              //this.templateTypeChange(this.moduletemplate.template_type, true);
              this.courseTypeGroupChange(this.moduletemplate.coursetypegroup_id)
              this.moduleoptions_list()
            })
            .catch((err) => console.log(err))
        }
      })
    },
    setReadOnly() {
      if (this.$hasRole("system-developer")) {
        this.allow_edit = true
        this.allow_delete = true
        return
      }

      if (_.has(this.moduletemplate, "id")) {
        this.allow_edit = this.$can("moduletemplate-edit") && this.moduletemplate.template_type !== 0

        this.allow_delete = this.$can("moduletemplate-delete") && this.moduletemplate.template_type !== 0
      } else {
        this.allow_edit = true
        this.allow_delete = false
      }

      if (this.allow_edit) {
        //this.$delete(this.dd_moduletemplate_template_type, 0)
      }
    },
    setPageTitle() {
      if (_.has(this.moduletemplate, "id")) {
        this.page_title = this.$t("moduletemplates.edit_moduletemplate", {
          name: this.moduletemplate.name
        })
      } else {
        this.page_title = this.$t("moduletemplates.new_moduletemplate")
      }
    },
    templateTypeChange(type, firstLoad = false) {
      axios.get(this.API_URL + "coursetypegroups?show_all=true&query_type=" + type).then((res) => {
        this.coursetypegroups = res.data.data

        this.coursetypes = []

        if (!firstLoad) {
          this.moduletemplate.coursetype_id = null
        }
      })
    },
    courseTypeGroupChange(groupId) {
      axios.get(this.API_URL + "coursetypes?show_all=true&query_coursetypegroup_id=" + groupId).then((res) => {
        this.coursetypes = res.data.data
      })
    },
    changeHideInAccomplishment() {
      if (this.moduletemplate.hide_in_accomplishment) {
        this.moduletemplate.hide_in_enrolment = 0
      }
    },
    changeHideInEnrolment() {
      if (this.moduletemplate.hide_in_enrolment) {
        this.moduletemplate.hide_in_accomplishment = 0
      }
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.moduletemplate.id) {
              // Create
              axios
                .post(this.API_URL + "moduletemplate", {
                  name: this.moduletemplate.name,
                  description: this.moduletemplate.description,
                  req_hours: this.moduletemplate.req_hours,
                  req_coursetemplate_id: this.moduletemplate.req_coursetemplate_id,
                  req_module_id: this.moduletemplate.req_module_id,
                  coursetypegroup_id: this.moduletemplate.coursetypegroup_id || null,
                  coursetype_id: this.moduletemplate.coursetype_id || null,
                  type: this.moduletemplate.type,
                  template_type: this.moduletemplate.template_type,
                  price: this.moduletemplate.price,
                  price_vat: this.moduletemplate.price_vat,
                  status: this.moduletemplate.status,
                  is_included: this.moduletemplate.is_included,
                  is_joint: this.moduletemplate.is_joint,
                  select_visibility: this.moduletemplate.select_visibility,
                  hide_in_accomplishment: this.moduletemplate.hide_in_accomplishment,
                  hide_in_enrolment: this.moduletemplate.hide_in_enrolment,
                  internal_note: this.moduletemplate.internal_note,
                  mandatory: this.moduletemplate.mandatory,
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.moduletemplate = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.moduletemplate))
                      vm.$awn.success(vm.$t("global.create_success"))

                      if (vm.modal) {
                        vm.$emit("return_modal_form", {
                          module: "moduletemplate",
                          mode: "add",
                          data: res.data.data
                        })
                      } else {
                        vm.setPageTitle()
                        vm.moduleoptions_list()
                        vm.$router.replace(this.BACKEND_URL + `/moduletemplates/edit/${vm.moduletemplate.id}`).catch(() => {})
                      }
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "moduletemplate", {
                  id: this.moduletemplate.id,
                  name: this.moduletemplate.name,
                  description: this.moduletemplate.description,
                  req_hours: this.moduletemplate.req_hours,
                  req_coursetemplate_id: null,
                  req_module_id: this.moduletemplate.req_module_id,
                  req_coursetemplate_id: this.moduletemplate.req_coursetemplate_id,
                  coursetypegroup_id: this.moduletemplate.coursetypegroup_id || null,
                  coursetype_id: this.moduletemplate.coursetype_id || null,
                  type: this.moduletemplate.type,
                  template_type: this.moduletemplate.template_type,
                  price: this.moduletemplate.price,
                  price_vat: this.moduletemplate.price_vat,
                  status: this.moduletemplate.status,
                  is_included: this.moduletemplate.is_included,
                  is_joint: this.moduletemplate.is_joint,
                  select_visibility: this.moduletemplate.select_visibility,
                  hide_in_accomplishment: this.moduletemplate.hide_in_accomplishment,
                  hide_in_enrolment: this.moduletemplate.hide_in_enrolment,
                  internal_note: this.moduletemplate.internal_note,
                  mandatory: this.moduletemplate.mandatory
                })
                .then((res) => {
                  vm.moduletemplate = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.moduletemplate))

                  vm.setPageTitle()
                  vm.$awn.success(vm.$t("global.update_success"))

                  if (vm.modal) {
                    vm.$emit("return_modal_form", {
                      module: "moduletemplate",
                      mode: "edit",
                      data: res.data.data
                    })
                  }
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "moduletemplate/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/moduletemplates")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    del_option(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "moduleoption/" + id)
            .then((res) => {
              vm.moduleoptions_list()
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    del_option_ct(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "moduleoptioncoursetype/" + id)
            .then((res) => {
              vm.moduleoptions_list()
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    showForm(id, type, mid) {
      if (!this.moduletemplate.id) {
        this.$awn.warning(this.$t("moduletemplates.save_first"))
      } else {
        this.currentFormId = id

        if (type == "moduleoption") this.currentModuleTemplateId = mid
        if (type == "moduleoptioncoursetype") this.currentModuleOptionId = mid

        this.currentForm = type + "-form"
      }
    },
    return_modal_form(data) {
      this.return_modal_cancel_form()
      this.moduleoptions_list()
    },
    return_modal_cancel_form() {
      this.currentForm = ""
      this.currentModuleTemplateId = ""
      this.currentModuleOptionId = ""
      this.showDialogForm = false
    },
    moduleoptions_list() {
      this.show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, {
        moduletemplate_id: this.moduletemplate.id
      })

      axios
        .get(this.API_URL + "moduleoptions" + "?" + query)
        .then((res) => {
          this.moduleoptions = res.data.data
          this.total = res.data.meta.total
          this.refresh = false
          this.show_loading = false

          this.pagination.page = res.data.meta.current_page
          this.pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
        .catch((err) => console.log(err))
    },
    duplicate() {
      let vm = this

      this.$awn.confirm(
        this.$t("moduletemplates.duplicate_message"),
        () => {
          axios
            .post(this.API_URL + "moduletemplate/duplicate/" + this.moduletemplate.id)
            .then((res) => {
              let moduletemplate = res.data.data

              if (moduletemplate) {
                vm.$router.push(this.BACKEND_URL + "/moduletemplates/edit/" + moduletemplate.id)
                vm.init()
                vm.$awn.success(vm.$t("global.create_success"))
              }
            })
            .catch((err) => console.log(err))
        },
        () => {
          return
        }
      )
    },
    moduleOptionOrder(id, increase) {
      var data = []
      var ctr = 1
      var idx = this.moduleoptions.findIndex((i) => i.id == id)
      var newIdx = null

      if (increase) {
        newIdx = idx++
      } else {
        newIdx = idx--
      }

      this.moduleoptions.swapItems(idx, newIdx)

      this.moduleoptions.forEach((item, index) => {
        item.order = ctr
        data.push({ id: item.id, order: item.order })
        ctr++
      })

      axios
        .put(this.API_URL + "moduletemplate/moduleoptionorder", {
          data: data
        })
        .then((res) => {})
        .catch((err) => console.log(err))
    }
  }
}
</script>

<style>
.form-modal {
  background: white;
}
.ct-td {
  padding: 9px !important;
  background: var(--v-secondary-base) !important;
}
.tr-no-bottom-border td {
  border-bottom: 0 !important;
}
.mandatory-chkbox {
  margin-top: 18px !important;
  margin-right: 30px !important;
}
.mandatory-chkbox .v-input__slot {
  margin-bottom: 0 !important;
}
.mandatory-chkbox.v-input--checkbox .v-label {
  color: #fff !important;
}
</style>
